import { CommonModule } from '@angular/common';
import { inject } from "@angular/core";
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { Store } from '@ngxs/store';
import { NotificationsState } from '../state/notifications.state';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
const _c0 = a0 => ({
  "has-unread-messages": a0
});
function NotificationsInfoIconComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, i0.ɵɵpipeBind1(1, 2, ctx_r0.unread$) > 0));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, ctx_r0.unread$));
  }
}
function NotificationsInfoIconComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("size", 20)("margin", false);
  }
}
export let NotificationsInfoIconComponent = /*#__PURE__*/(() => {
  class NotificationsInfoIconComponent {
    constructor() {
      this.loadedCount$ = inject(Store).select(NotificationsState.loadedCount);
      this.unread$ = inject(Store).select(NotificationsState.unread);
    }
    static {
      this.ɵfac = function NotificationsInfoIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsInfoIconComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: NotificationsInfoIconComponent,
        selectors: [["notifications-info-icon"]],
        decls: 5,
        vars: 3,
        consts: [["id", "iconwrapper"], ["icon", "bell", "size", "2x"], ["id", "counter", 3, "ngClass"], [1, "spinner", 3, "size", "margin"]],
        template: function NotificationsInfoIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "ui-icon", 1);
            i0.ɵɵconditionalCreate(2, NotificationsInfoIconComponent_Conditional_2_Template, 5, 8, "div", 2);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵconditionalBranchCreate(4, NotificationsInfoIconComponent_Conditional_4_Template, 1, 2, "ui-spinner", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 1, ctx.loadedCount$) ? 2 : 4);
          }
        },
        dependencies: [CommonModule, i1.NgClass, UiIconsModule, i2.UiIconComponent, UiSpinnerComponent, i1.AsyncPipe],
        styles: ["#iconwrapper[_ngcontent-%COMP%]{position:relative;display:inline-block}#iconwrapper[_ngcontent-%COMP%]    >fa-icon{display:block}.spinner[_ngcontent-%COMP%], #counter[_ngcontent-%COMP%]{position:absolute;top:14px;left:13px;width:20px;height:20px}#counter[_ngcontent-%COMP%]{border-radius:10px;display:flex;justify-content:center}#counter[_ngcontent-%COMP%]{background:var(--primaryColor);color:#fff;font-size:14px;line-height:20px}#counter.has-unread-messages[_ngcontent-%COMP%]{background:#ff463edb}"]
      });
    }
  }
  return NotificationsInfoIconComponent;
})();